import { SlidesAction, ADD_ITEM, REMOVE_ITEM } from '../actions/slides.actions';
import { EntityAdapter, EntityState, createEntityAdapter } from "@ngrx/entity";
import { SlideItem } from '../../models';

export interface SlidesSate extends EntityState<SlideItem> {
    staged: any[];
    title: string;
}

const slidesAdapter = createEntityAdapter<SlideItem>();
// const slid

const slidesState: SlidesSate = slidesAdapter.getInitialState({
    staged: [],
    title: 'Default Title'
});

export function slidesReducer(state: SlidesSate = slidesState, action: SlidesAction): SlidesSate {
    switch (action.type) {
        case ADD_ITEM: {
            return slidesAdapter.addOne(action.payload, state);
        }

         case REMOVE_ITEM: {
             return slidesAdapter.removeOne(action.payload.id, state);
         }
    }
    return state;
}

export const staged = (state: SlidesSate) => state.staged;
export const title = (state: SlidesSate) => state.title;
